import React from "react";
import styled from "@emotion/styled";

const StyledLink = styled.a`
  border-bottom: 1px solid ${({ theme }) => theme.colors.night};
  color: ${({ theme }) => theme.colors.night};
  hyphens: auto;
  text-decoration: none;

  &:hover {
    border-bottom-color: ${({ theme }) => theme.colors.jungle};
    color: ${({ theme }) => theme.colors.jungle};
  }
`;

export const ReferralUserLink = ({ userId }: { userId: string }) => (
  <StyledLink href={`/${userId}`} title="View profile">
    View profile
  </StyledLink>
);
